import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {EsBsModalService} from '@src/app/services/bsModalService/bs-modal.service';
import {PaywallWarnService} from '@modules/paywall/services/paywallWarnService/paywall-warn.service';
import {HttpServiceService} from '@src/app/services/httpService/http-service.service';
import {HttpHeaders, HttpParams} from '@angular/common/http';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-paywall-warn-template-modal',
  templateUrl: './paywall-warn-template-modal.html',
  styleUrls: ['./paywall-warn-template-modal.scss']
})
export class PaywallWarnTemplateModalComponent implements OnInit {
  private upgradeUrl = 'event/log-paywall-upgrade';
  public Yiit = Yiit;
  public currentMessage: string;
  constructor(private bs: EsBsModalService, private paywallWS: PaywallWarnService, private cd: ChangeDetectorRef, private http: HttpServiceService) { }

  ngOnInit() {
    this.paywallWS.updateMessageAndOpen$.pipe(debounceTime(100)).subscribe((message)=>{
      this.currentMessage = message;
      this.cd.detectChanges();
      this.showPaywallWarnModal();
    })
  }

  private sendUpdatePackageToServer(){
    const csrfFrontend = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement).content;
      this.http.sendPostRequest(this.upgradeUrl,
        new HttpParams().set('_csrf-frontend', csrfFrontend.toString()),
        new HttpHeaders({
          'Content-Type':  'application/x-www-form-urlencoded'
        })
      ).subscribe();
  }

  getPricingLink() {
    return 'https://www.oneplanevents.com/pricing/';
  }

  openUpgradeNowPopup() {
    this.sendUpdatePackageToServer();
    this.bs.closeModal();
    this.bs.currentModal = '#update-now-popup';
    this.bs.openModal();
  }

  showPaywallWarnModal(){
    if(this.bs.currentModal != '#paywall-warning-error-modal'){
      this.bs.closeModal();
    }
    this.bs.openModal({modalId: '#paywall-warning-error-modal'});
  }
}
